import { useState, useEffect } from "react";
import React, { Component } from "react";
import { Wheel } from "react-custom-roulette";
import ConfettiExplosion, { ConfettiProps } from "react-confetti-explosion";
import "./App.css";
import RewardVideo from "./RewardAd";
import {saveTelegramLog} from "./SaveTelegramLog"

export default function WheelGame() {
  const [loading, setLoading] = useState(true);
  const [playAnimation, setPlayAnimation] = useState(false);
  const [isExploding, setIsExploding] = useState(false);
  const [activeToken, setActiveToken] = useState("");
  const [data, setData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [spinAllowed, setSpinAllowed] = useState(false);
  const [spinText, setSpinText] = useState("LOADING..");
  const [spinTime, setSpinTime] = useState(-1);
  const [timer, setTimer] = useState(false);
  const [wheelData, setWheelData] = useState([]);
  const [spinFetch, setSpinFetch] = useState(false);
  const [wheelMargin, setWheelMargin] = useState(30);
  const [adDone, setAdDone] = useState(false);
  const playSound = () => {
    const audio = new Audio(require("./assets/wheelsound.mp3")); // Path to your sound file
    audio.play();
  };
  const updateTimer = () => {};
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (timer == false || spinTime == -1) {
        return false;
      }
      var t = spinTime;
      t = t - 1;
      if (t == 0) {
        setSpinAllowed(true);
        setSpinTime(-1);
        setTimer(false);
      } else {
        setSpinTime(t);
        var hours = Math.floor(t / 3600); // 1 hour = 3600 seconds
        var minutes = Math.floor((t % 3600) / 60); // Remaining minutes after hours are extracted
        var seconds = t % 60;
        if (seconds < 10) seconds = "0" + seconds;
        if (minutes < 10) minutes = "0" + minutes;
        if (hours < 10) hours = "0" + hours;
        setSpinText(`${hours} : ${minutes} : ${seconds}`);
      }
    }, 1000); // 3 seconds
    // Cleanup the timeout when the component unmounts
    return () => clearTimeout(timeoutId);
  }, [spinTime]);
  /*
    const data = [
      { option: 'No Luck', style: { textColor: '#fff' }  },
      { option: '2x Rewards' , style: { textColor: '#fff' } },
      { option: 'No Luck' , style: { textColor: '#fff' } },
      { option: '2x Rewards', style: { textColor: '#fff' } },
      { option: 'No Luck' , style: { textColor: '#fff' } },
      { option: '3x Rewards' , style: { textColor: '#fff' } },
      { option: 'No Luck', style: { textColor: '#fff' }  },
      { option: '4x Rewards' , style: { textColor: '#fff' } },
    ];
    */
  const getSpinButton = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + activeToken);
    const raw = "";
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(global.getBaseUrl() + "/user/claim_cooldown", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        if (result.error && result.message.indexOf('Unauthorized') !== -1) {
          console.log('Logout From 8',result);
          global.logoutNow();
        } else {
          const timestampToCompare = result.cooldown;
          const currentTimestamp = Math.floor(Date.now() / 1000); // Current Unix timestamp (in seconds)
          console.log(currentTimestamp);
          if (timestampToCompare <= currentTimestamp) {
            setSpinAllowed(true);
            setSpinTime(-1);
            setTimer(false);
          } else {
            const differenceInSeconds = Math.abs(
              timestampToCompare - currentTimestamp
            ); // Absolute difference to avoid negative values
            setSpinTime(differenceInSeconds);
            setTimer(true);
            setSpinAllowed(false);
          }
          setDataLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };
  const getSpins = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + activeToken);
    const raw = "";
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(global.getBaseUrl() + "/wheel/wins", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        if (result.error && result.message.indexOf('Unauthorized') !== -1) {
          console.log('Logout From 9',result);
          global.logoutNow();
        } else {
          setWheelData(result);
          var temp = [];
          for (var j = 0; j < result.length; j++) {
            temp[j] = {};
            temp[j]["option"] = result[j]["short_title"];
            temp[j]["style"] = {};
            temp[j]["style"]["textColor"] = "#fff";
          }
          setData(temp);
          setLoading(false);
          getSpinButton();
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };
  const largeProps: ConfettiProps = {
    force: 0.8,
    duration: 3000,
    particleCount: 300,
    width: 1600,
    colors: ["#041E43", "#1471BF", "#5BB4DC", "#FC027B", "#66D805"],
  };
  const backgroundColors = [
    "#0bbcb6",
    "#40407a",
    "#ff5252",
    "#218c74",
    "#474787",
    "#ff793f",
    "#34ace0",
    "#ffb142",
  ];
  const textColors = ["#0b3351"];
  const outerBorderColor = "#474787";
  const outerBorderWidth = 0;
  const innerBorderColor = "#fff";
  const innerBorderWidth = 0;
  const innerRadius = 0;
  const radiusLineColor = "#fff";
  const radiusLineWidth = 1;
  const fontFamily = "Bungee";
  const fontWeight = "bold";
  const fontSize = 12;
  const fontStyle = "normal";
  const textDistance = 60;
  const spinDuration = 0.5;
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [previousPrize, setPreviousPrize] = useState(0);
  const [adDisplay,setAdDisplay] = useState(false);


  const handleSpinClick = () => {
    hideAdNow();
    setWheelMargin(120);
    setSpinFetch(true);
    saveTelegramLog();
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + activeToken);
    const raw = "";
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(global.getBaseUrl() + "/wheel/spin", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setSpinAllowed(false);
        result = JSON.parse(result);
        if (result.error && result.message.indexOf('Unauthorized') !== -1) {
          console.log('Logout From 10',result);
          global.logoutNow();
        } else {
          var win = result.result;
          var rf = false;
          for (var j = 0; j < wheelData.length; j++) {
            if (wheelData[j]["id"] === win && rf === false) {
              rf = true;
              if (!mustSpin) {
                setPrizeNumber(j);
                setMustSpin(true);
                setPlayAnimation(false);
                setTimeout(function () {
                  playSound();
                }, 500);
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (activeToken != "") {
      getSpins();
    }
  }, [activeToken]);
  useEffect(() => {
    if (localStorage.getItem("USERDATA")) {
      var dd = localStorage.getItem("USERDATA");
      dd = JSON.parse(dd);
      setActiveToken(dd.token);
    }
  }, []);
  useEffect(() => {
    updateTimer();
  }, [timer]);


  const showAds = () => {
      setAdDisplay(true);
    };
    const hideAdNow = () => {
      setAdDisplay(false);
    };
    

  return (
    <div className="section wheelBack1">
      {adDisplay ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 200000,
            }}
          >
            <RewardVideo
              callBack={handleSpinClick}
              callBackArgs={""}
            ></RewardVideo>
          </div>
        </>
      ) : null}
      <div
        style={{
          padding: 20,
          textAlign: "left",
          width: "100%",
        }}
      >
        <div className="mainHeading">
          <i
            className="fa-solid fa-gamepad"
            style={{
              fontSize: 16,
              marginTop: -3,
            }}
          ></i>
          &nbsp;&nbsp;Wheel Of Fortune
        </div>
        <div
          style={{
            position: "absolute",
            top: 60,
            width: "100%",
            height: 350,
            left: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        ></div>
        <div
          style={{
            marginTop: wheelMargin,
            textAlign: "center",
            transition: "margin-top 0.5s ease", // Animate directly in style
          }}
        >
          {dataLoaded ? (
            <>
              <Wheel
                mustStartSpinning={mustSpin}
                prizeNumber={prizeNumber}
                data={data}
                backgroundColors={backgroundColors}
                textColors={textColors}
                fontFamily={fontFamily}
                fontSize={fontSize}
                fontWeight={fontWeight}
                fontStyle={fontStyle}
                outerBorderColor={outerBorderColor}
                outerBorderWidth={outerBorderWidth}
                innerRadius={innerRadius}
                innerBorderColor={innerBorderColor}
                innerBorderWidth={innerBorderWidth}
                radiusLineColor={radiusLineColor}
                radiusLineWidth={radiusLineWidth}
                spinDuration={spinDuration}
                startingOptionIndex={previousPrize}
                // perpendicularText
                textDistance={textDistance}
                onStopSpinning={() => {
                  setMustSpin(false);
                  console.log("Result is " + data[prizeNumber]["option"]);
                  setPlayAnimation(true);
                  setWheelMargin(30);
                }}
              />
            </>
          ) : (
            <></>
          )}
          <br />
          <br />
          {playAnimation ? (
            <>
              <div
                className="winTag"
                style={{
                  marginTop: 30,
                }}
              >
                <div className="animate__animated animate__zoomInUp">
                  <div
                    className="glitch-wrapper"
                    style={{
                      width: "100%",
                      height: 40,
                      backgroundColor: "transparent",
                    }}
                  >
                    <div
                      className="glitch"
                      data-glitch={data[prizeNumber].option}
                      style={{
                        fontSize: 40,
                      }}
                    >
                      <span
                        style={{
                          color: backgroundColors[prizeNumber],
                        }}
                      >
                        {wheelData[prizeNumber].short_title}
                      </span>
                    </div>
                  </div>
                  <br />
                  <div
                    style={{
                      fontSize: 20,
                    }}
                  >
                    {wheelData[prizeNumber].long_title}
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  {data[prizeNumber].option.indexOf("No Luck") == -1 ? (
                    <>
                      <ConfettiExplosion {...largeProps} />
                      <br />
                      <div className="row animate__animated animate__zoomInUp">
                        <div className="col-12">
                          <div
                            className="button"
                            onClick={() => {
                              setSpinFetch(false);
                              setPlayAnimation(false);
                              getSpinButton();
                            }}
                            style={{
                              borderRadius: 5,
                              backgroundColor: backgroundColors[prizeNumber],
                            }}
                          >
                            <a
                              href="#"
                              style={{
                                backgroundColor: backgroundColors[prizeNumber],
                                boxShadow: "none",
                              }}
                            >
                              <i className="fa-solid fa-rotate-right"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className="button animate__animated animate__zoomInUp"
                        onClick={() => {
                          setPlayAnimation(false);
                        }}
                        style={{
                          borderRadius: 5,
                          backgroundColor: backgroundColors[prizeNumber],
                        }}
                      >
                        <a
                          href="#"
                          style={{
                            backgroundColor: backgroundColors[prizeNumber],
                            boxShadow: "none",
                          }}
                        >
                          <i className="fa-solid fa-rotate-right"></i>
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {spinAllowed ? (
                <>
                  <div
                    class="button animate__animated animate__zoomInUp"
                    onClick={() => {
                      if (spinFetch === false) {
                        showAds();
//                        showAdNow();
//                        handleSpinClick();
                        //                          showAdmob();
                      }
                    }}
                  >
                    <a href="#">SPIN NOW</a>
                  </div>
                </>
              ) : (
                <>
                  {dataLoaded ? (
                    <>
                      <div 
                        class="button animate__animated animate__zoomInUp"
                        style={{
                          display: spinFetch ? "none" : "block",
                        }}
                      >
                        <a href="#WHEEL">
                          Next Spin In
                          <br />
                          {spinText}
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <span className="loader"></span>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      <div style={{
        height:300
      }}></div>
    </div>
  );
}
